export default __webpack_public_path__ + "static/media/contact.6724fdb4.png";